module.exports = __webpack_public_path__ + "media/images/icon-strategic-advice-f7909bb675fc13377e0c2057d2d240e1.svg";